export const SET_DASHBOARDS_LOADED = "SET_DASHBOARDS_LOADED";

export const setDashboardsLoaded = (dashboardsLoaded: boolean) => {
  return {
    dashboardsLoaded,
    type: SET_DASHBOARDS_LOADED
  };
};
